import { useBoolean, useString } from "helpers/hooks"
import {
  fileArrayToFileList,
  formatDate,
  processImageFiles,
  removeImageBySrc,
  removeTimestampInFileName,
} from "helpers/utils"
import { useEffect, useMemo, useRef, useState } from "react"
import ReactQuill, { Quill } from "react-quill"
import "react-quill/dist/quill.snow.css"
import { ReactComponent as TimestampIcon } from "assets/images/icons/icon-editor-timestamp.svg"
import { ReactComponent as EditorFileIcon } from "assets/images/icons/icon-editor-file.svg"
import { ReactComponent as EditorTextBoldIcon } from "assets/images/icons/icon-editor-bold.svg"
import { ReactComponent as EditorTextItalicIcon } from "assets/images/icons/icon-editor-italic.svg"
import { ReactComponent as EditorTextColorIcon } from "assets/images/icons/icon-editor-text-color.svg"
import { ReactComponent as EditorTextBulletListIcon } from "assets/images/icons/icon-editor-bullet-list.svg"
import { ReactComponent as EditorNumberListIcon } from "assets/images/icons/icon-editor-ordered-list.svg"
import { ReactComponent as EditorOrderListIcon } from "assets/images/icons/icon-ordered-list.svg"
import { ReactComponent as EditorImageIcon } from "assets/images/icons/icon-editor-image.svg"
import { ReactComponent as AddApprovalIcon } from "assets/images/icons/add-approval.svg"
import { ReactComponent as FolderAddIcon } from "assets/images/icons/folder-add.svg"


import FileEditorCard from "pages/project-component-detail/molecules/FileEditorCard"
import ImageResize from "quill-image-resize-module-react"
import Tippy from "@tippyjs/react"
import ReactDOMServer from "react-dom/server"
import { FileEditorDetail } from "pages/project-component-detail/types"
import Button from "components/Button/Button"
import { TippyCustomzie } from "components/TippyCustomzie"
import ActionIconHistory from "pages/project-component-detail/molecules/ActionIconHistory"
import ActionItem from "pages/projects/molecules/ActionItem"
import LabelNotificationPage from "components/Notification/LabelNotificationPage"
import DraftToHtml from "draftjs-to-html"
import { toast } from "react-toastify"
import Delayed from "components/Delayed"
import { cloneDeep, isUndefined } from "lodash"
const icons = Quill.import("ui/icons")

const List = Quill.import("formats/list")

class CustomNumberedList extends List {
  static blotName = "custom-numbered"
  static tagName = "OL"
  static className = "custom-numbered"
}

Quill.register(CustomNumberedList, true)

window.Quill = Quill
Quill.register("modules/imageResize", ImageResize)
const MAX_FILE_SIZE = 2 * 1000 * 1000 // 2MB

interface ReplyMessage {
  id: string
  content: string
  user: {
    fullname: string
    email: string
  }
}

interface Props {
  value: string
  setValue: (value: string) => void
  handleDeleteFileDownload?: (index: number, idFile?: string) => () => void
  listFileUrl?: FileEditorDetail[]
  handleAddFiles: (
    originFiles: FileEditorDetail[],
    files: FileList,
    type?: "inline" | "outline",
    imageUrl?: string,
    fileInLine?: FileList,
    fileInLineUrl?: { name: string; imageUrl: string }[]
  ) => void
  listFileAdd: FileEditorDetail[]
  keyInputFile: string
  idPart?: string
  handleDeleteFileNoDownload?: (oldIndex: number) => () => void
  readOnly?: boolean
  styleFileEditorCard?: React.CSSProperties
  styleRootListFile?: React.CSSProperties
  styleIconAddFIle?: React.CSSProperties
  styleRootCard?: React.CSSProperties
  onSubmitButton?: (dataEditor: string) => void
  isDisableButton?: boolean
  styleListFile?: React.CSSProperties
  isBlur?: boolean
  conversationId?: string
  versionId?: string
  isDropImage?: boolean
  decryptedShareKey?: string
  dbKey?: string
  subNameDownload: string
  approveEditor?: React.ReactNode
  onAddApproval?: () => void
  replyMessage?: ReplyMessage | null
  onCancelReply?: () => void
  onScrollToReplyMessage?: () => void
}

const CustomToolbar = ({ id }: { id: string }) => {
  return (
    <div id={id} className={`toolbar flex gap-1 text-editor ${id}`}>
      <div className="">
        <select
          className="ql-header"
          defaultValue={""}
          onChange={(e) => e.persist()}
        >
          <option value="1" />
          <option value="2" />
          <option selected />
        </select>
      </div>
      <div className="h-[20px] bg-stroke  w-[0.5px]"></div>

      <Tippy placement="top" content={"Bold"} offset={[0, 15]}>
        <button className="ql-bold" />
      </Tippy>
      <Tippy placement="top" content={"Italic"} offset={[0, 15]}>
        <button className="ql-italic" />
      </Tippy>
      <Tippy placement="top" content={"Text color"} offset={[0, 15]}>
        <div>
          <select className="ql-color">
            <option value="red" />
            <option value="green" />
            <option value="blue" />
            <option value="orange" />
            <option value="violet" />
            <option value="#d0d1d2" />
            <option selected />
          </select>
        </div>
      </Tippy>
      <Tippy
        placement="top"
        className=""
        content={"Ordered list"}
        offset={[0, 15]}
      >
        <button className=" ql-list" value={"ordered"} />
      </Tippy>
      <Tippy placement="top" content={"Numbered list"} offset={[0, 15]}>
        <button className="ql-custom-numbered">
          <EditorNumberListIcon />
        </button>
      </Tippy>
      <Tippy
        placement="top"
        className=""
        content={"Bulleted list"}
        offset={[0, 15]}
      >
        <button className=" ql-list" value={"bullet"} />
      </Tippy>
    </div>
  )
}

const InputEditor2 = (props: Props) => {
  const [containerQuill] = useState(
    `quill${Math.random().toString(36).slice(2)}`
  )
  const {
    setValue,
    listFileUrl,
    handleDeleteFileDownload,
    handleAddFiles,
    listFileAdd,
    handleDeleteFileNoDownload,
    idPart,
    readOnly = false,
    onSubmitButton,
    isDisableButton,
    conversationId,
    versionId,
    isDropImage = true,
    subNameDownload,
    approveEditor,
    onAddApproval,
    replyMessage,
    onCancelReply,
    onScrollToReplyMessage,
  } = props
  let value = props.value
  try {
    const draftContent = JSON.parse(value)
    if (draftContent) {
      value = DraftToHtml(draftContent)
    }
  } catch (error) { }
  const quillRef = useRef<any>(`${versionId}-${conversationId}`)
  const editorValue = useString(value)
  const isFocus = useBoolean()
  const showTippy = useBoolean()

  const isEnableSubmitButton = editorValue.value || listFileAdd.length

  const isInsert = useRef(false)
  const filePaste = useRef<File[]>([])
  const newCursorPosition = useRef(0)
  const isPasteData = useRef(false)
  const isShowDropFile = useBoolean(false)
  const dragCounter = useRef(0)


  useEffect(() => {
    editorValue.setValue(value)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value])



  const isValidLink = (text: string): boolean => {
    const urlRegex = /^(https?:\/\/)?([\w\d-]+\.)+[\w]+(\/[\w\d-./?%&=]*)?$/i
    return urlRegex.test(text)
  }

  useEffect(() => {
    const originQuill = quillRef.current?.editor // Get Quill instance
    if (!originQuill) return

    const handlePaste = async (event: ClipboardEvent) => {
      const clipboardData = event.clipboardData || (window as any).clipboardData
      const files: File[] = Array.from(clipboardData.files)
      if (files.length) {
        isPasteData.current = true
        filePaste.current = files
        const a = cloneDeep(newCursorPosition.current)
        setTimeout(() => {
          insertPasteFiles(a)
        }, 100)
      }
      const pastedText = clipboardData?.getData("text")
      if (pastedText && isValidLink(pastedText)) {
        originQuill.format("link", pastedText)
      }
    }

    originQuill.root.addEventListener("paste", handlePaste)
    return () => originQuill.root.removeEventListener("paste", handlePaste)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quillRef.current, newCursorPosition.current, JSON.stringify(listFileAdd)])

  const validateFileSize = (files: any) => {
    const totalSizeMB =
      files.reduce((sum, f) => sum + f.size, 0) / (1024 * 1024)
    if (totalSizeMB > 50) {
      toast(
        <LabelNotificationPage
          type="error"
          messenger={`The upload of file larger than ${50}MB is not allowed`}
        />
      )
      return true
    }
    return false
  }
  const getFileNotExisted = (originFiles: File[]) => {
    let newFiles: File[] = []
    let fileNameChecked: string[] = []
    if (!isUndefined(listFileUrl) && listFileUrl.length > 0) {
      fileNameChecked = listFileUrl.map((el) =>
        removeTimestampInFileName(el.name)
      )
    }
    if (fileNameChecked.length > 0) {
      originFiles.forEach((file) => {
        if (!fileNameChecked.includes(file.name)) {
          newFiles.push(file)
        } else {
          toast(
            <LabelNotificationPage
              type="error"
              messenger={`File ${file.name} already exists`}
            />
          )
        }
      })
    } else {
      newFiles = originFiles
    }
    const result: File[] = []

    const nameCount = new Map<string, number>()

    for (const elFileAdd of listFileAdd) {
      const match = elFileAdd.name.match(/^(.*) \((\d+)\)(\.[^.]+)$/)

      if (match) {
        const baseName = `${match[1]}${match[3]}`
        const version = parseInt(match[2], 10)
        nameCount.set(elFileAdd.name, 0)
        const currentMax = nameCount.get(baseName) ?? 0
        nameCount.set(baseName, Math.max(currentMax, version))
      } else {
        if (!nameCount.has(elFileAdd.name)) {
          nameCount.set(elFileAdd.name, 0)
        }
      }
    }

    for (const elFile of newFiles) {
      const extIndex = elFile.name.lastIndexOf(".")
      const name =
        extIndex !== -1 ? elFile.name.slice(0, extIndex) : elFile.name
      const ext = extIndex !== -1 ? elFile.name.slice(extIndex) : ""
      let newName = elFile.name
      if (!nameCount.has(elFile.name)) {
        nameCount.set(elFile.name, 0)
        newName = elFile.name
      } else {
        let countFile = nameCount.get(elFile.name) || 0
        newName = `${name} (${countFile + 1})${ext}`
        nameCount.set(elFile.name, countFile + 1)
        nameCount.set(newName, 0)
      }
      const renamedFile = new File([elFile], newName, {
        type: elFile.type,
        lastModified: elFile.lastModified,
      })

      result.push(renamedFile)
    }
    return result
  }

  const insertPasteFiles = async (newPosition: number) => {
    if (validateFileSize(filePaste.current)) {
      isPasteData.current = false
      return
    }
    if (isDropImage) {
      isPasteData.current = false
    }

    await insertFilesToEditor(
      getFileNotExisted(filePaste.current),
      newPosition + 1
    )

    filePaste.current = []

    if (!isDropImage) {
      isPasteData.current = false
    }
  }



  // Convert File sang base64 để đảm bảo image hiển thị được
  const fileToBase64 = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.onload = () => {
        if (typeof reader.result === 'string') {
          resolve(reader.result)
        } else {
          reject(new Error('Failed to convert file to base64'))
        }
      }
      reader.onerror = reject
      reader.readAsDataURL(file)
    })
  }

  const imageHandler = async () => {
    const input = document.createElement("input")
    input.setAttribute("type", "file")
    input.setAttribute("accept", "image/*")
    input.click()
    input.onchange = async function () {
      const file = input && input.files ? input.files[0] : null
      const files = input && input.files ? input.files : null
      if (!file) return
      if (!files) return
      if (!isFileSizeValid(file)) {
        return toast(
          <LabelNotificationPage
            type="warning"
            messenger="Image have to be smaller than 2Mb."
          />
        )
      }
      const newFiles: File[] = getFileNotExisted([file])
      if (newFiles.length) {
        const reader = new FileReader()
        reader.onload = function (e) {
          if (!e.target?.result) return
          const quill = quillRef?.current?.getEditor()
          const cursorPosition = quill.getSelection()?.index || 0
          const blob = new Blob([e.target?.result], { type: file.type })
          const imageUrl = URL.createObjectURL(blob)
          handleAddFiles(
            listFileAdd,
            fileArrayToFileList(newFiles),
            "inline",
            imageUrl
          )
          quill.insertEmbed(cursorPosition, "image", imageUrl)
          quill.setSelection(cursorPosition + 1)
        }
        reader.readAsArrayBuffer(file)
      }
    }
  }

  const onChangeEditor = async (newValue: string) => {
    const sanitizedNew = newValue?.trim().replace(/[\r\n]/gm, "")
    const sanitizedOld = value?.trim().replace(/[\r\n]/gm, "")

    if (sanitizedNew === sanitizedOld || isPasteData.current) return

    if (newValue !== editorValue.value) {
      editorValue.setValue(newValue)
      setValue(newValue)
    }
  }
  const onDeleteFileNoDownload =
    (oldIndex: number, file: FileEditorDetail) => () => {
      if (handleDeleteFileNoDownload) {
        if (file.type === "inline") {
          const updatedEditorValue = removeImageBySrc(
            editorValue.value,
            file.url || ""
          )
          onChangeEditor(updatedEditorValue)
          isFocus.setValue(true)
        }
        handleDeleteFileNoDownload(oldIndex)()
      }
    }

  const insertFiles = async () => {
    const input = document.createElement("input")
    input.setAttribute("type", "file")
    input.setAttribute("accept", "*")
    input.setAttribute("multiple", "true")
    input.click()
    input.onchange = async function (event) {
      const files = input ? input.files : null
      if (!files) return
      const fileInsert = Array.from(files)

      if (validateFileSize(fileInsert)) {
        return
      }
      const newFiles: File[] = getFileNotExisted(fileInsert)

      if (newFiles.length) {
        handleAddFiles(listFileAdd, fileArrayToFileList(newFiles))
      }
    }
  }
  const insertTimestamp = () => {
    if (isInsert.current) return
    const currentTimestamp = formatDate(new Date())
    const quill = quillRef?.current?.getEditor()
    const insertPos = newCursorPosition.current || 0
    quill.insertText(newCursorPosition.current || 0, currentTimestamp, {
      color: "#FF8C00",
    })
    quill.format("color", "black")
    quill.insertText(insertPos + currentTimestamp.length, " ", {
      color: false,
    })

    quill.setSelection(insertPos + currentTimestamp.length + 1)
    isInsert.current = true
    setTimeout(() => {
      isInsert.current = false
    }, 500)
  }
  const indentBindings = {
    indent: {
      key: "Tab",
      format: ["list", "custom-numbered"],
      handler(range: any, context: any) {
        const indent = context.format.indent || 0
        if (indent >= 4) return false

        const quill = quillRef.current?.getEditor?.()
        if (quill) {
          quill.format("indent", indent + 1)
        }
      },
    },
    outdent: {
      key: "Tab",
      shiftKey: true,
      format: ["list", "custom-numbered"],
      handler(range: any, context: any) {
        const indent = context.format.indent || 0
        if (indent <= 0) return false

        const quill = quillRef.current?.getEditor?.()
        if (quill) {
          quill.format("indent", indent - 1)
        }
      },
    },
  }
  const modules = useMemo(() => {
    icons.bold = ReactDOMServer.renderToString(<EditorTextBoldIcon />)
    icons.italic = ReactDOMServer.renderToString(<EditorTextItalicIcon />)
    icons.color = ReactDOMServer.renderToString(<EditorTextColorIcon />)
    icons.list.bullet = ReactDOMServer.renderToString(
      <EditorTextBulletListIcon />
    )
    icons.list.ordered = ReactDOMServer.renderToString(<EditorOrderListIcon />)
    var Image = Quill.import("formats/image")
    Image.sanitize = function (url) {
      return url
    }
    return {
      toolbar: {
        container: `#${containerQuill}`,
        handlers: {
          image: imageHandler,
          insertTimestamp,
          insertFiles,
          "custom-numbered": function () {
            const quill = quillRef.current?.getEditor?.()
            if (!quill) return
            const format = quill.getFormat()
            const isActive = format["custom-numbered"]
            // Reset old format
            quill.format("list", isActive ? false : "ordered")
            quill.format("custom-numbered", !isActive)
          },
        },
      },
      clipboard: {
        matchVisual: false,
      },
      imageResize: {
        parchment: Quill.import("parchment"),
        modules: ["Resize", "Toolbar"],
      },
      keyboard: {
        bindings: indentBindings,
      },
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [containerQuill])

  const handleDrop = async (event: React.DragEvent<HTMLInputElement>) => {
    event.preventDefault()
    event.stopPropagation()
    dragCounter.current = 0
    isShowDropFile.setValue(false)
    const fileInsert = Array.from(event.dataTransfer.files)
    if (validateFileSize(fileInsert)) {
      return
    }
    const newFiles: File[] = getFileNotExisted(fileInsert)
    if (isDropImage) {
      insertFilesToEditor(newFiles, newCursorPosition.current)
      return
    }
    handleAddFiles(listFileAdd, fileArrayToFileList(newFiles))
  }

  const insertFilesToEditor = async (files: File[], newPosition: number) => {
    if (isDropImage) {
      const imageFiles = files.filter(
        (file) => file.type.startsWith("image/") && isFileSizeValid(file)
      )
      const otherFiles = files.filter((file) => !file.type.startsWith("image/"))

      const imageFileNotValid = files.filter(
        (el) => el.type.startsWith("image/") && !isFileSizeValid(el)
      )
      const newURLFiles = await processImageFiles(imageFiles)

      if (files.length) {
        handleAddFiles(
          listFileAdd,
          fileArrayToFileList(otherFiles.concat(imageFileNotValid)),
          undefined,
          undefined,
          fileArrayToFileList(imageFiles),
          newURLFiles
        )
      }
      if (newURLFiles.length) {
        handleImageFileInput(newURLFiles, newPosition)
      }
      if (imageFileNotValid.length) {
        imageFileNotValid.forEach((file) => {
          showFileSizeWarning(file.name)
        })
      }
      return
    }
    handleAddFiles(listFileAdd, fileArrayToFileList(files))
  }

  const handleImageFileInput = (
    files: {
      name: string
      imageUrl: string
    }[],
    newPosition: number
  ) => {
    const quill = quillRef?.current?.getEditor()
    for (const file of files) {
      insertImageToEditor(file, quill, newPosition)
    }
  }

  const isFileSizeValid = (file: File): boolean => {
    return file.size <= MAX_FILE_SIZE
  }

  const showFileSizeWarning = (fileName: string) => {
    toast(
      <LabelNotificationPage
        type="warning"
        messenger={`Image ${fileName} have to be smaller than 2Mb.`}
      />
    )
  }

  const insertImageToEditor = (
    file: {
      name: string
      imageUrl: string
    },
    quill: any,
    newPosition: number
  ) => {
    quill.insertEmbed(newPosition, "image", file.imageUrl)
    quill.setSelection(newPosition + 1)
  }

  const handleDragEnter = (e) => {
    // if (!isDropImage) return
    e.preventDefault()
    e.stopPropagation()

    dragCounter.current += 1

    if (dragCounter.current === 1) {
      isShowDropFile.setValue(true)
    }

  }
  const handleDragLeave = (e) => {
    // if (!isDropImage) return
    e.preventDefault()
    e.stopPropagation()

    dragCounter.current -= 1
    if (dragCounter.current === 0) {
      isShowDropFile.setValue(false)
    }

  }

  const handleSelectionChange = (range: any) => {
    if (range && !isUndefined(range.index)) {
      newCursorPosition.current = range.index
    }
  }

  const isChangeHeight =
    ((listFileUrl && listFileUrl.length && handleDeleteFileDownload) ||
      (listFileAdd &&
        listFileAdd.length !== 0 &&
        handleDeleteFileNoDownload)) &&
    approveEditor

  const renderListFile = () => {
    return (
      <div className="flex items-center gap-x-[4px] flex-1 min-w-0"

      >
        {(listFileUrl?.length || listFileAdd?.length) && approveEditor ? (
          <p className="text-[12px] leading-[18px] font-medium flex-shrink-0">
            Attachments:
          </p>
        ) : null}
        <div className="flex items-center gap-x-[4px] overflow-x-auto flex-1 min-w-0"

        >
          {listFileUrl && listFileUrl.length && handleDeleteFileDownload
            ? listFileUrl.map((file, index) => (
              <FileEditorCard
                key={index}
                index={index}
                name={file.name}
                isDownload={true}
                isDeleted={!readOnly}
                idFile={file.id}
                handleDeleteFile={handleDeleteFileDownload}
                urlFile={file.file}
                conversationId={conversationId}
                versionId={versionId}
                decryptedShareKey={props.decryptedShareKey}
                dbKey={props.dbKey}
                subNameDownload={subNameDownload}
                styleFileEditorCard={{
                  margin: 0,
                }}
              />
            ))
            : null}
          {listFileAdd &&
            listFileAdd.length !== 0 &&
            handleDeleteFileNoDownload &&
            listFileAdd.map((file, index) => (
              <FileEditorCard
                key={`${index}${file.name}`}
                index={index}
                name={file.name}
                isDownload={false}
                isDeleted={true}
                urlFile={file.file}
                handleDeleteFile={() => onDeleteFileNoDownload(index, file)}
                conversationId={conversationId}
                subNameDownload=""
                styleFileEditorCard={{
                  margin: 0,
                }}
              />
            ))}
        </div>
      </div>
    )
  }

  const renderFooter = () => {
    if (approveEditor) {
      return (
        <div className="flex flex-col justify-center gap-[2px] rounded-2 bottom-[0px] w-full px-3 pb-[6px]"


        >
          {renderListFile()}
          <div className="flex items-center gap-[4px] justify-between"

          >
            {approveEditor}
            <div className="">
              {onSubmitButton ? (
                <Button
                  title="Submit"
                  onClick={() => {
                    onSubmitButton(editorValue.value)
                  }}
                  disabled={
                    !isEnableSubmitButton || readOnly || isDisableButton
                  }
                  isDisabledBtn
                  sizeBtn="small"
                />
              ) : null}
            </div>
          </div>
        </div>
      )
    }
    return (
      <div className="flex items-center gap-[8px] rounded-2 bottom-[0px] w-full px-3 pb-[6px]"

      >
        {renderListFile()}
        {onSubmitButton ? (
          <Button
            title="Submit"
            onClick={() => {
              onSubmitButton(editorValue.value)
            }}
            disabled={!isEnableSubmitButton || readOnly || isDisableButton}
            isDisabledBtn
            sizeBtn="small"
          />
        ) : null}
      </div>
    )
  }

  return (
    <div className="text-editor relative w-full flex flex-col gap-1 ">
      <div
        className={`${readOnly ? "hidden" : "flex"
          } items-center pr-2 rounded-full bg-black-04 w-fit `}
      >
        <CustomToolbar id={containerQuill} />
        {/* desktop */}
        <div className="hidden md:block">
          {!idPart && (
            <Tippy placement="top" content={"Image"} offset={[0, 15]}>
              <button
                className="ql-image text-editor p-1 hover:bg-[#7a7a7a] rounded-[6px]"
                onClick={imageHandler}
              >
                <EditorImageIcon />
              </button>
            </Tippy>
          )}

          <Tippy placement="top" content={"Add timestamp"} offset={[0, 15]}>
            <button
              onClick={insertTimestamp}
              className="ql-insertTimestamp text-editor p-1 hover:bg-[#7a7a7a] rounded-[6px]"
            >
              <TimestampIcon />
            </button>
          </Tippy>
          <Tippy placement="top" content={"Files"} offset={[0, 15]}>
            <button
              className="text-editor p-[2px] hover:bg-[#7a7a7a] rounded-[6px]"
              onClick={insertFiles}
            >
              <EditorFileIcon />
            </button>
          </Tippy>
          {approveEditor ? (
            <Tippy placement="top" content={"Add approval"} offset={[0, 15]}>
              <button
                className="text-editor p-[2px] hover:bg-[#7a7a7a] rounded-[6px]"
                onClick={onAddApproval}
              >
                <AddApprovalIcon />
              </button>
            </Tippy>
          ) : null}
        </div>

        {/* mobile */}
        <TippyCustomzie
          containerClass="md:hidden component-card-menu reset-tippy"
          placement="top-end"
          interactive
          arrow={false}
          animation="scale"
          visible={showTippy.value}
          onClickOutside={() => showTippy.setValue(false)}
          content={
            <div
              style={{
                background: "#222222",
                borderRadius: 4,
                paddingTop: 8,
                paddingBottom: 8,
                width: 165,
              }}
            >
              {!idPart && (
                <ActionItem
                  title={"Insert image"}
                  onClick={imageHandler}
                  icon={<EditorImageIcon />}
                />
              )}

              <ActionItem
                title={"Insert files"}
                onClick={insertFiles}
                icon={<EditorFileIcon />}
              />
              <ActionItem
                title={"Insert timestamp"}
                onClick={insertTimestamp}
                icon={<TimestampIcon />}
              />
            </div>
          }
          allowHTML
        >
          <div
            className="flex items-center"
            onClick={() => {
              showTippy.setValue(true)
            }}
          >
            <ActionIconHistory
              icon="three-dots"
              tooltip="Action"
              styleIcon={{
                marginRight: 0,
              }}
            />
          </div>
        </TippyCustomzie>
      </div>

      <div

        className={`w-full rounded-4 border-[1.5px] flex flex-col border-gray-300 ${isFocus.value ? "active-project-build" : ""
          }`}
        style={{
          overflow: "hidden",
        }}
      >
        {/* Reply Bar */}
        {replyMessage && onCancelReply ? (
          <div style={{
            background: "rgba(86, 160, 18, 0.15)",
            borderLeft: "4px solid rgb(86, 160, 18)",
            padding: "6px",
            margin: "6px 6px 0px 6px",
            borderRadius: "4px",
            cursor: "pointer",
          }}
            onClick={onScrollToReplyMessage}
          >
            <div className="flex items-start">
              <div className="flex-1 min-w-0">
                <p
                  className="font-bold text-13 leading-22"
                  style={{
                    color: "#111111",
                    marginBottom: 4,
                  }}
                >
                  {replyMessage.user.fullname} - {replyMessage.user.email}
                </p>
                <p
                  className="font-normal text-12 leading-18"
                  style={{
                    color: "#111111",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    display: "-webkit-box",
                    WebkitLineClamp: 1,
                    WebkitBoxOrient: "vertical",
                  }}
                >
                  {(() => {
                    const tmp = document.createElement("DIV")
                    tmp.innerHTML = replyMessage.content
                    return tmp.textContent || tmp.innerText || ""
                  })()}
                </p>
              </div>
              <div
                className="cursor-pointer ml-2 flex-shrink-0"
                onClick={(event) => {
                  event.stopPropagation()
                  event.preventDefault()
                  onCancelReply()
                }
                }
                style={{
                  width: 20,
                  height: 20,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 4L4 12M4 4L12 12"
                    stroke="#111111"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            </div>
          </div>
        ) : null}
        <div className="mt-[10px] relative "
          onDrop={handleDrop}
          onDragOver={(e) => e.preventDefault()}
          onDragEnter={handleDragEnter}
          onDragLeave={handleDragLeave}
        >
          <Delayed waitBeforeShow={200}>
            <ReactQuill
              key={`${versionId}/${conversationId}/editor/${containerQuill}`}
              className={`w-full pl-2 text-black leading-3 overflow-auto rich-editor`}
              ref={quillRef}
              value={editorValue.value}
              onChange={onChangeEditor}
              onFocus={() => isFocus.setValue(true)}
              onBlur={() => isFocus.setValue(false)}
              modules={modules}
              onChangeSelection={(range) => handleSelectionChange(range)}
              readOnly={readOnly}
              theme="snow"
              formats={[
                "header",
                "bold",
                "italic",
                "underline",
                "strike",
                "blockquote",
                "list",
                "bullet",
                "indent",
                "link",
                "image",
                "code",
                "color",
                "background",
                "code-block",
                "align",
                "width",
                "custom-numbered",
              ]}
            />
          </Delayed>
          {isShowDropFile.value ? <div className="absolute left-0 top-0 right-0 bottom-0 pl-[4px] pr-[4px] pb-[4px] z-[100]">
            <div className="flex flex-col items-center justify-center h-full w-full gap-[4px] "
              style={{
                background: "#0A5AF526",
                borderRadius: 8,
                border: '1px dashed #0A5AF526'
              }}>
              <FolderAddIcon className="icon-blue" />
              <p className="text-[14px] font-bold text-[#111111] ">Drop your files here</p>
              <p className="text-[12px] text-[#7A7A7A] italic">Drop files here to add to this context (max 50MB)</p>
            </div>
          </div> : null}
        </div>
        {renderFooter()}
      </div>
    </div>
  )
}
export default InputEditor2